import { OyResponse } from '@oy/types';
import { AUTH_MULTI_ACCOUNT_PREFIX, MULTI_ACCOUNT_PREFIX } from 'src/clients';
import { AccountStatementData } from 'src/models/Reports';

export const MULTI_ACCOUNT_MANAGEMENT_CHILDREN_STATEMENT_URL = `${MULTI_ACCOUNT_PREFIX}/child/account-statement`;
export const MULTI_ACCOUNT_MANAGEMENT_CHILDREN_LIST_URL = `${AUTH_MULTI_ACCOUNT_PREFIX}/child`;

export type ChildData = {
  availableBalance: number;
  availableOverdraft: number;
  balance: number;
  bankCode: string;
  bankName: string;
  brandName: string;
  childKybStatus: string;
  childType: string;
  pendingBalance: number;
  receivingAccount: string;
  receivingAccountName: string;
  receivingBankCode: string;
  relationId: string;
  status: string;
  username: string;
  vaName: string;
  vaNumber: string;
};

export type ChildStatementData = {
  brandName: string;
  internalTxNote: string;
  lastUpdateBy: string;
} & AccountStatementData;

export type ChildUsernameStatusParams = {
  username: string;
};

export type ChildTopUpParams = {
  recipientUsername: string;
  amount: number;
  senderEmail?: string;
};

export type GetChildrenListParams = {
  limit?: number;
  offset?: number;
  order_by?: string;
  brand_name?: string;
  vaNumber?: string;
  vaName?: string;
};

export type GetChildrenStatementParams = {
  brand_name?: string;
  limit?: number;
  offset?: number;
  order_by?: string;
  start_date?: string;
  end_date?: string;
  tx_status?: string;
  tx_product?: string;
};

export type ChildUsernameStatusData = {
  codeStatus: string;
  messageStatus: string;
};

export type GetChildrenListData = {
  totalChild: number;
  pagination: {
    page: number;
    total: number;
    limit: number;
    data: ChildData[];
  };
  totalChildWithNoKybData: number;
};

export type GetChildStatementData = {
  page: number;
  total: number;
  limit: number;
  data: ChildStatementData[];
};

export type GetChildTypeData = {
  childUsername: string;
  childType: string;
  updatedBy: string | null;
};

export type ChildTopUpData = {
  trxId: string;
  status: {
    code: string;
    message: string;
  };
};

export type ChildUsernameStatusResponse = OyResponse<ChildUsernameStatusData>;
export type GetChildrenListResponse = OyResponse<GetChildrenListData>;
export type GetChildStatementResponse = OyResponse<GetChildStatementData>;
export type GetChildTypeResponse = OyResponse<GetChildTypeData>;
export type ChildTopUpResponse = OyResponse<ChildTopUpData>;
